import axios from 'axios'
import { useAuthStore } from './store'

// const API_BASE_URL = 'http://localhost:5000/api/v1/admin'
// const API_BASE_URL = 'http://localhost:5000/api/v1/admin'



const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL

if (!API_BASE_URL && typeof window !== 'undefined') {
  console.error('NEXT_PUBLIC_API_URL is not set. Please check your environment variables.')
}

export const api = axios.create({
  baseURL: API_BASE_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors
let isRedirecting = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect if we're not already on the login page and not already redirecting
      if (
        typeof window !== 'undefined' && 
        !window.location.pathname.includes('/login') &&
        !isRedirecting
      ) {
        isRedirecting = true;
        useAuthStore.getState().logout();
        
        // Clear token cookie
        fetch("/api/auth/clear-token", {
          method: "POST",
        }).finally(() => {
          window.location.href = '/login';
        });
      }
    }
    return Promise.reject(error)
  }
)

export default api 